import { Stack, Typography } from "@mui/material";

const TitleHeader = ({
  title,
  mb = 0,
  mt = 0,
  fs = 28,
  fw = 700,
  el = "h1",
  sx = {},
  color = "#111111",
  children,
}) => {
  return (
    <Stack>
      <Typography
        component={el}
        display="flex"
        alignItems="center"
        color={color}
        mb={mb}
        mt={mt}
        sx={{ fontSize: fs, fontWeight: fw, ...sx }}
      >
        {title}
        {children}
      </Typography>
    </Stack>
  );
};

export default TitleHeader;
